import type { ComponentProps } from 'react';
import { cn } from '../lib/utils.ts';

/** The ReAct mark: two orbit arcs and the coral dot. Same artwork as public/favicon.svg. */
export function BrandMark({ className, ...props }: ComponentProps<'svg'>) {
  return (
    <svg viewBox="0.5 0.5 113 113" fill="none" className={cn('shrink-0', className)} {...props}>
      <g className="stroke-brand-ink" strokeLinecap="round">
        <path d="M60.18 17.92A44.25 44.25 0 1 0 96.26 54.96" strokeWidth="14.5" />
        <path d="M53.33 37.76A23.75 23.75 0 1 0 75.99 57.99" strokeWidth="11.5" />
      </g>
      <circle cx="102.5" cy="11.5" r="10" className="fill-brand-coral" />
    </svg>
  );
}

/** "Re" in ink, "Act" in coral. */
export function BrandWordmark({ className }: { className?: string }) {
  return (
    <span className={cn('font-bold tracking-tight', className)}>
      <span className="text-brand-ink">Re</span>
      <span className="text-brand-coral">Act</span>
    </span>
  );
}
